import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { IonSearchbar, ModalController } from "@ionic/angular";

export interface PickerItem {
  id: number;
  label: string;
  sublabel?: string;
  /** Allerede tildelt: vises avkrysset og låst */
  disabled?: boolean;
}

/**
 * Søkbar flervalgsliste i modal (samme uttrykk som kundesøket).
 * Returnerer { ids: number[] } ved «Legg til», ingenting ved lukk.
 */
@Component({
  selector: "app-picker-modal",
  templateUrl: "./picker-modal.component.html",
  styleUrls: ["./picker-modal.component.scss"],
  standalone: false,
})
export class PickerModalComponent implements OnInit, AfterViewInit {
  /** Oversettelsesnøkkel for tittelen */
  @Input() titleKey = "";
  @Input() items: PickerItem[] = [];
  /** Oversettelsesnøkkel for tom liste */
  @Input() emptyKey = "Picker.noItems";

  @ViewChild("searchbar", { static: false }) searchbar: IonSearchbar;

  searchTerm = "";
  filteredItems: PickerItem[] = [];
  selected = new Set<number>();

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.filter();
  }

  ngAfterViewInit() {
    // Modal-animasjonen må være ferdig før fokus settes (samme som kundesøket)
    setTimeout(() => this.searchbar?.setFocus(), 400);
  }

  filter() {
    const term = (this.searchTerm || "").toLowerCase().trim();
    this.filteredItems = term
      ? this.items.filter(
          (item) =>
            item.label.toLowerCase().includes(term) ||
            (item.sublabel || "").toLowerCase().includes(term)
        )
      : this.items;
  }

  get selectableVisible(): PickerItem[] {
    return this.filteredItems.filter((item) => !item.disabled);
  }

  get allVisibleSelected(): boolean {
    const visible = this.selectableVisible;
    return (
      visible.length > 0 && visible.every((item) => this.selected.has(item.id))
    );
  }

  toggle(item: PickerItem) {
    if (item.disabled) {
      return;
    }
    if (this.selected.has(item.id)) {
      this.selected.delete(item.id);
    } else {
      this.selected.add(item.id);
    }
  }

  toggleAllVisible() {
    const select = !this.allVisibleSelected;
    for (const item of this.selectableVisible) {
      if (select) {
        this.selected.add(item.id);
      } else {
        this.selected.delete(item.id);
      }
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  confirm() {
    if (this.selected.size === 0) {
      return;
    }
    this.modalCtrl.dismiss({ ids: Array.from(this.selected) });
  }
}
